import { Link } from "react-router-dom";
import { categories } from "@/mocks/siteData";

export default function Footer() {
  return (
    <footer className="relative bg-foreground-900 text-white overflow-hidden">
      <div className="absolute inset-0 pointer-events-none select-none flex items-center justify-center opacity-[0.04]">
        <span className="text-[12vw] font-heading font-bold whitespace-nowrap">ACBUY</span>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block text-xl font-heading font-bold text-white mb-6">
              AcBuySpreadsheet
            </Link>
            <p className="text-sm text-white/60 leading-relaxed mb-6">
              The most updated AcBuy spreadsheet for fashion, sneakers, streetwear and trusted sellers. Updated weekly.
            </p>
            <p className="text-xs text-white/40">
              Reviewed by Buying Research Team<br />
              Last Updated: June 2026
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-5">Categories</h4>
            <div className="space-y-2.5">
              {categories.slice(0, 7).map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-5">More Categories</h4>
            <div className="space-y-2.5">
              {categories.slice(7).map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="block text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-5">Quick Links</h4>
            <div className="space-y-2.5 mb-8">
              <Link to="/" className="block text-sm text-white/60 hover:text-white transition-colors">
                Home
              </Link>
              <Link to="/article/acbuy-spreadsheet-guide-2026" className="block text-sm text-white/60 hover:text-white transition-colors">
                Ultimate Buying Guide
              </Link>
              <Link to="/article/acbuy-sneaker-spreadsheet-2026" className="block text-sm text-white/60 hover:text-white transition-colors">
                Shopping Guide
              </Link>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="block text-sm text-white/60 hover:text-white transition-colors"
              >
                Acbuy Spreadsheet
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="block text-sm text-white/60 hover:text-white transition-colors"
              >
                Buy It Now
              </a>
            </div>

            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-3">Follow Us</h4>
            <div className="flex items-center gap-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer" aria-label="Instagram">
                <i className="ri-instagram-line text-white"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer" aria-label="YouTube">
                <i className="ri-youtube-line text-white"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer" aria-label="Twitter">
                <i className="ri-twitter-x-line text-white"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; 2026 AcBuySpreadsheet. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-white/40 hover:text-white/60 transition-colors">Privacy Policy</a>
            <a href="#" className="text-xs text-white/40 hover:text-white/60 transition-colors">Terms of Service</a>
            <a href="#" className="text-xs text-white/40 hover:text-white/60 transition-colors">Editorial Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}